<template>
  <div class="p-2">
    <div class="flex flex-col shadow-md rounded-lg mx-8 border border-blue-600 max-w-lg mx-auto">
      <div class="border-blue-600 border-b bg-blue-400 text-blue-800 font-bold py-2 px-4 text-center rounded-t-lg">
          Instrucciones
      </div>
      <div class="p-4 border-l border-r border-b border-b-gray-800 rounded-b-lg text-gray-800">
        <div class="instruction-step"><span>Ingresa el número del pedido que buscas. Si es más de uno, puedes añadirlo y presionar el botón <span><i class="fas fa-search"></i></span> para ir sumándolos a la lista.</span></div>
        <div class="instruction-step flex flex-col flex-wrap">
          <div>Comprueba el estatus de tu pedido:</div>
          <div class="ml-6">
            <ul class="list-disc text-blue-800">
              <li>Si se encuentra <b>LISTO PARA RECOGER</b> acércate al punto de entrega del local.</li>
              <li>Si todavía está en fase de <b>PREPARACIÓN</b>, espera en los alrededores del restaurante.</li>
              <li>Si no encuentras tu pedido, pregunta al staff.</li>
            </ul>
          </div>
        </div>
        <div class="instruction-step"><span>Los pedidos se actualizan solos o con el botón <span><i class="fas fa-sync"></i></span>. Cuando cambien de estado, lo reflejaremos en pantalla.</span></div>
        <div class="instruction-step-alert text-red-600">
          Respeta en todo momento las distancias de seguridad (+1.5m) y evita aglomeraciones.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PleaceFooter',
  props: {
    place: Object
  },
  data() {
    return {
       api_url: process.env.VUE_APP_URL_API
    }
  },
}
</script>

<style scoped lang="scss">

</style>
